import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import { RegistrationLinkFormValues } from '../Add/AddRegistrationLinkFormWrapper';
import useBatches from "src/hooks/useBatches";
import ATMSelect from 'src/components/UI/atoms/formFields/ATMSelect/ATMSelect';


type Props = {
  formikProps: FormikProps<RegistrationLinkFormValues>;
  onClose: () => void;
};

const RegistrationLinkForm = ({ formikProps, onClose }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const { batches, isDataLoading } = useBatches();

  const batchOptions= batches?.map((el:any)=>{
    return{
      label: el?.batchName ,
      value: el?._id
    }
  })

  return (
    <div className='p-4 flex flex-col gap-6'>
      <div className='flex justify-between items-center'>
        <div className='text-xl font-medium'>Add Registration Link</div>
        <button type='button' className='hover:bg-hover' onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className='flex flex-col gap-4'>
      <div className="mt-4">
            <ATMSelect
              name="batchId"
              value={values?.batchId} 
              isLoading={isDataLoading}
              label="Batches"
              placeholder="Select Batch"
              options={batchOptions}
              onChange={(newValue) => setFieldValue("batchId", newValue)}
              onBlur={handleBlur}
            />
          </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type='submit'>
          Save
        </ATMLoadingButton>
      </div>
    </div>
   
  );
};

export default RegistrationLinkForm;